import { render, staticRenderFns } from "./RebartheoryIndex.vue?vue&type=template&id=5623d600&scoped=true&"
import script from "./RebartheoryIndex.vue?vue&type=script&lang=js&"
export * from "./RebartheoryIndex.vue?vue&type=script&lang=js&"
import style0 from "./RebartheoryIndex.vue?vue&type=style&index=0&id=5623d600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5623d600",
  null
  
)

export default component.exports